import { useCallback, useMemo } from 'react';
import { useCookies } from 'react-cookie';

const defaultCategoryCookieName = 'stockx_homepage';

const useVertical = (urlFormatted = false) => {
  const [cookies, setCookie] = useCookies([defaultCategoryCookieName]);

  const currentVertical = useMemo(() => {
    const value = cookies[defaultCategoryCookieName] || 'sneakers';
    if (urlFormatted && value.includes(' ')) {
      return value.replace(' ', '-'); // trading-cards
    }

    return value;
  }, [cookies, urlFormatted]);

  const setCurrentVertical = useCallback(
    (vertical) => {
      if (vertical !== 'browseverticals') {
        setCookie(defaultCategoryCookieName, vertical, {
          path: '/',
          maxAge: 3.154e7,
        });
      }
    },
    [setCookie],
  );

  return [currentVertical, setCurrentVertical];
};

export default useVertical;
